import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRegistered } from "@fortawesome/free-solid-svg-icons";
import video1 from "../../video/pexels-pavel-danilyuk-5495898.mp4";
import video2 from "../../video/res.mp4";
import {
  faFacebook,
  faGithub,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import Typewriter from "typewriter-effect";
import "./slider.css";
const Slider = () => {
  return (
    <div className="video-section">
      <video src={video1} muted loop autoPlay className="visible"></video>
      <video src={video2} muted loop autoPlay className="notVisible"></video>
      <div className="video-overly"></div>
      <div className="text container mt-5 animate__animated animate__fadeInLeft  pb-5 ">
        <div className="needSpacingForBeautyness">
          <>
            <h5 className="pt-5">Welcome To My World</h5>
            <h1>
              This Is <span>Riaz</span>
            </h1>
            <div className="visible">
              <h1 className="customize ">
                {" "}
                I'm A{" "}
                <span className="need-more-position">
                  <Typewriter
                    options={{
                      strings: [
                        "Web Designer",
                        "Web Developer",
                        "MERN Stack Developer",
                        "React JS Developer",
                        "Javascript Developer",
                      ],
                      autoStart: true,
                      loop: true,
                    }}
                  />{" "}
                </span>
              </h1>
            </div>
            <div className="notVisible">
              <h1 className="customize ">
                {" "}
                I'm A{" "}
                <span className="need-more-position">
                  <Typewriter
                    options={{
                      strings: [
                        "Web Designer",
                        "Web Developer",
                        "ReactJS Developer",
                        "JS Developer",
                      ],
                      autoStart: true,
                      loop: true,
                    }}
                  />{" "}
                </span>
              </h1>
            </div>
            <p style={{ lineHeight: "34px" }}>
              Web Design & Development is my passion , Always I Do Hard Work To
              Make it Success <br />I Always Try To Make Something Better Than
              Others.
            </p>
            <div className="social-icon d-flex mt-1">
              <p className="font-changing">
                Visit My Social Media -
                <a href="https://www.facebook.com/nisshongojiboner.pothik/">
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a href="">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a href="https://www.linkedin.com/in/riaz-ahmed-akhanda-752b84210/">
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a href="https://github.com/riazakhanda017ksn">
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </p>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default Slider;
